import Routes from '@/config/routes/routes.js'

try {
  if (/^\/etpfs.*/.test(window.location.pathname)) {
    Routes.configure({
      default_url_options: {
        trailing_slash: true,
      },
      prefix: '/etpfs',
    })
  } else {
    Routes.configure({
      default_url_options: {
        trailing_slash: true,
      },
    })
  }
} catch (err) {
  throw err
}

export const routes = Routes

export { Routes }
